import { useTranslation } from 'react-i18next'

import { getEnvs } from '../../utils/env'

const { env } = getEnvs()

export const EnvInfo = () => {
  const { t } = useTranslation()

  return (
    <>
      <b>{t('Environment')}:</b> {env}
    </>
  )
}
